import { UserProfession, UserSubProfession } from "../enums/UserProfession";
import { getShouldAllowAdminToPostProcedure, getShouldAllowOfficeToPostProcedureBasedOnProfession } from "../growthbook";

export const DefaultGeneralSpecialty = 'specialty_General Dentistry';

export const getIsAllowOfficeToPostProcedure = (professionType, skills) => {
  /** always show procedures when profession is DN */
  const isDNShowProcedures =
    professionType === UserProfession.getName(UserProfession.DN);

  /** show procedures when profession is DA and specialty is non general densistry */
  const isDAShowProcedures =
    (professionType === UserProfession.getName(UserProfession.DA) ||
      professionType === UserSubProfession.getName(UserSubProfession.EFDA)) &&
    skills !== DefaultGeneralSpecialty;

  /**
   * is show procedure based on (`isDNShowProcedures` == TRUE OR `isDAShowProcedures` == TRUE)
   * AND FF `TEMP-11985-should-allow-office-to-post-procedure-based-on-profession` ON
   *  */
  const isShowProceduresBasedOnProfession =
    (isDNShowProcedures || isDAShowProcedures) &&
    getShouldAllowOfficeToPostProcedureBasedOnProfession();

  /**
   * is show procedure if FF `should-allow-office-to-post-procedure` ON
   * OR `isShowProceduresBasedOnProfession` is TRUE
   *  */
  const isShowProceduresLine =
    getShouldAllowAdminToPostProcedure() || isShowProceduresBasedOnProfession;

  return isShowProceduresLine;
};
